import api from '../api';

class ManagementDashboardV2Data {
  getFilters() {
    return api.get('/admin_dashboard_v2/filters');
  }

  getTeamLeaderFilters() {
    return api.get('/admin_dashboard_v2/team-leader/filters');
  }

  getTeamLeaderOverview(filters) {
    return api.post('/admin_dashboard_v2/team-leader/overview', filters);
  }

  requestTeamLeaderCsvExport(filters) {
    return api.post('/admin_dashboard_v2/team-leader/csv', filters);
  }

  getOverview(filters) {
    return api.post('/admin_dashboard_v2/overview', filters);
  }

  requestCsvExport(filters) {
    return api.post('/admin_dashboard_v2/csv', filters);
  }

  downloadGeneratedCsv() {
    return api.get('/admin_dashboard_v2/download-csv', {
      responseType: 'blob',
    });
  }
}

export default new ManagementDashboardV2Data();
